import { render, staticRenderFns } from "./WHBrandFrom.vue?vue&type=template&id=0ea8b112&"
import script from "./WHBrandFrom.vue?vue&type=script&lang=js&"
export * from "./WHBrandFrom.vue?vue&type=script&lang=js&"
import style0 from "./WHBrandFrom.vue?vue&type=style&index=0&id=0ea8b112&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports